var Utility = (function () {


  /** ********************************** */
  /*
  /* DEBOUNCE
  /* Returns a function, that, as long as it continues to be invoked, will not
  /* be triggered. The function will be called after it stops being called for
  /* N milliseconds. If `immediate` is passed, trigger the function on the
  /* leading edge, instead of the trailing.
  /*
  /******************************************************** */

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }


  /** ********************************** */
  /*
  /* LOG, DEBUG, WARN, ERROR
  /* removes Utility.log, console.debug, console.warn & console.error calls
  /*   in production environment
  /* see: https://gist.github.com/nathansmith/5631193
  /*
  /******************************************************** */

  // Debug on localhost
  var host = window.location.hostname;
  var debug = host.match(/localhost|127.0.0.1|dev.acura.corp.possible.com|qa.acura.corp.possible.com/);

  // Safely log things
  function log() {
    if (debug && console && typeof console.log === 'function') {
      for (var i = 0, ii = arguments.length; i < ii; i++) {
        console.log(arguments[i]);
      }
    }
  }

  // Safely log things in blue
  function logBlue() {
    if (debug && console && typeof console.debug === 'function') {
      for (var i = 0, ii = arguments.length; i < ii; i++) {
        console.debug(arguments[i]);
      }
    }
  }

  // Safely warn things
  function warn() {
    if (debug && console && typeof console.warn === 'function') {
      for (var i = 0, ii = arguments.length; i < ii; i++) {
        console.warn(arguments[i]);
      }
    }
  }

  // Safely error things
  function error() {
    if (debug && console && typeof console.error === 'function') {
      for (var i = 0, ii = arguments.length; i < ii; i++) {
        console.error(arguments[i]);
      }
    }
  }

  /** ********************************** */
  /*
  /* CREATE HTML
  /* Create an HTML string to be inserted into the DOM.
  /*
  /* htmlStr: the HTML to be inserted into a root element
  /* rootElement: the element type to insert the htmlStr
  /*    into (e.g. 'section', 'div', 'ul')
  /* rootClass: (optional) a class name to add to the root element
  /* data: (optional) JSON object of attributes, like HTML 5 "data-*"
  /* attributes.
  /*
  /******************************************************** */
  function createHTML(htmlStr, rootElement, rootClass, attributes) {
    if (rootElement !== null) {
      var frag = document.createDocumentFragment();
      var temp = document.createElement(rootElement);
      temp.innerHTML = htmlStr;
      if (rootClass !== null) {
        temp.className = rootClass;
      }
      if (attributes) {
        for (var key in attributes) {
          temp.setAttribute(key, attributes[key]);
        }
      }
      frag.appendChild(temp);
      return frag;
    }
    Utility.error(
      'Utility.createHTML() requires that you send it a root element'
      + ' (rootElement) to insert the html string (htmlStr) into.',
    );
  }

  function loadSvgInMemory() {
    var svgPath = '/Areas/AcuraPlatform/icons/systems.svg';
    var svgsLoadedEvent = createEvent('svgsLoaded', {});
    if (Acr && Acr.svgLoadedInMemory !== true) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        if (this.status.toString() !== '404') {
          Acr.svgLoadedInMemory = true;
          Acr.SvgList = parseSVGString(this.responseText);
          window.dispatchEvent(svgsLoadedEvent);
        }
      };
      xhr.onerror = function (e) {
        Utility.error('loadSVGs() Error:' + e.message);
      };
      xhr.open('get', svgPath, true);
      xhr.send();
    }
  }

  function svgLoader() {
    var scripts = document.getElementsByTagName('script');
    var script = scripts[scripts.length - 1];
    if (Acr && Acr.svgLoaded !== true) {
      Acr.svgLoaded = true;
      for (var i = 0; i < arguments.length; i++) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
          if (this.status.toString() !== '404') {
            var div = document.createElement('div');
            div.id = 'svgs-container';
            div.innerHTML = this.responseText;
            div.style.display = 'none';
            script.parentNode.insertBefore(div, script);
          }
        };
        xhr.onerror = function (e) {
          Utility.error('Utility.svgLoader() Error:' + e.message);
        };
        xhr.open('get', arguments[i], true);
        xhr.send();
      }
    }
  }

  function parseSVGString(svgString) {
    var parser; var xmlDoc; var symbolList; var
      svgObject;
    parser = new DOMParser();
    xmlDoc = parser.parseFromString(svgString, 'text/xml');
    symbolList = xmlDoc.getElementsByTagName('symbol');
    svgObject = {};
    for (var i = 0; i < symbolList.length; i++) {
      svgObject[symbolList[i].id] = {
        viewBox: symbolList[i].getAttribute('viewBox'),
        content: symbolList[i],
      };
    }
    return svgObject;
  }

  function removeClassFromSvg(svg, className) {
    if (svg[0]) {
      var svgClass = svg[0].getAttribute('class');
      var removedClass = svgClass.replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');
      if (svgClass.indexOf(className) > -1) {
        svg[0].setAttribute('class', removedClass);
      }
    }
  }

  function addClassToSvg(svg, className) {
    if (svg[0]) {
      var svgClass = svg[0].getAttribute('class');
      if (!(svgClass.indexOf(className) > -1)) {
        svg[0].setAttribute('class', svgClass + ' ' + className);
      }
    }
  }

  /** ********************************** */
  /*
  /* CLASS
  /* Add class name to an element.
  /*
  /* className: the name of the class you want to add
  /* element: the element you want to add the className on
  /*
  /******************************************************** */
  function addClass(className, element) {
    if (element.classList) { element.classList.add(className); } else { element.className += ' ' + className; }
  }


  /** ********************************** */
  /*
  /* REMOVE CLASS
  /* Remove class name to an element.
  /*
  /* className: the name of the class you want to remove
  /* element: the element you want to remove the className from
  /*
  /******************************************************** */
  function removeClass(className, element) {
    if (element.classList) { element.classList.remove(className); } else {
      element.className = element.className.replace(new RegExp('(^|\\b)'
        + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }

  /** ********************************** */
  /*
  /* HAS CLASS
  /* Returns true if element has class name.
  /*
  /* className: the name of the class you want to remove
  /* element: the element you want to remove the className from
  /*
  /******************************************************** */
  function hasClass(className, element) {
    if (element !== null && element.className) {
      return new RegExp('(\\s|^)'
        + className + '(\\s|$)').test(element.className);
    }
    return false;

  }


  /** ********************************** */
  /*
  /* TOGGLE CLASS
  /* Add/remove class name to all elements that have a particular class name.
  /*
  /* className: the name of the class you want to toggle
  /* elementName: the class name of the elements you want to find
  /*   and toggle the className on
  /*
  /******************************************************** */
  function toggleClass(className, elementName) {
    var el;
    var elements = document.querySelectorAll('.' + elementName);

    for (var i = 0; i < elements.length; i++) {
      el = elements[i];
      if (el.classList) {
        el.classList.toggle(className);
      } else {
        var classes = el.className.split(' ');
        var existingIndex = classes.indexOf(className);

        if (existingIndex >= 0) { classes.splice(existingIndex, 1); } else { classes.push(className); }

        el.className = classes.join(' ');
      }
    }
  }

  /**
   * Returns the element's children. Can include an element that won't
   * be returned even if it is one of the children of that element.
   *
   * @public
   * @param {HTMLElement} parent The parent HTMLElement to find children of.
   * @param {HTMLElement} excludeElement The child element to skip from the
   *    children returned (optional)
   * @return {Object[]} An array of HTMLElement objects that are children
   *    of the parent HTMLElement.
   *
   */
  function children(parent, excludeElement) {
    var r = [];
    for (; parent; parent = parent.nextSibling) {
      if (parent.nodeType === 1 && parent !== excludeElement) { r.push(parent); }
    }
    return r;
  }

  /**
   * Returns the element's siblings. Can include an element that won't
   * be returned even if it is one of the children of that element.
   *
   * @public
   * @param {HTMLElement} element The element to find siblings of.
   * @return {Object[]} An array of HTMLElement objects that are
   *   siblings to the HTMLElement
   *
   */
  function siblings(element) {
    return children(element.parentNode.firstChild, element);
  }

  /** ********************************** */
  /*
  /* OUTER WIDTH WITH MARGIN
  /* Returns outer width with the calculated margin.
  /*
  /* element: the element you want to find the width of
  /*
  /******************************************************** */
  function outerWidthWithMargin(element) {
    var width = element.offsetWidth;
    var style = getComputedStyle(element);

    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
  }

  /** ********************************** */
  /*
  /* QUICK DEEP CLONE
  /* Quickly deep clones an object for duplication into another object
  /*
  /* obj: the object to be cloned
  /*
  /******************************************************** */
  function quickDeepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  /** ********************************** */
  /*
  /* GUID
  /* Generates and returns a pseudo-guid (collision probability: 1 in 1,000,000)
  /*
  /* obj: the object to be cloned
  /*
  /******************************************************** */
  function guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-'
      + s4() + '-' + s4() + s4() + s4();
  }

  // Default-value function
  function defaultTo(value, defaultValue) {
    return typeof value !== 'undefined' ? value : defaultValue;
  }

  /** ********************************** */
  /*
  /* MOBILE vs. TABLET vs. DESKTOP Checks.
  /* Returns variables for use with JS code,
  /* which needs to target specific devices based on
  /* resolutions.
  /*
  /******************************************************** */
  function isMobile() {
    // iOS uses screen.width. However the Desktop (mobile size)
    // uses window.innerWidth & not screen.width.
    var isMobile = false;

    if (window.innerWidth < 550) { // Desktop Resized Browser Check
      isMobile = true;
    } else if ((screen.width < window.innerWidth)
      && (screen.width < 550)) { // iOS Check
      isMobile = true;
    }

    /* Here is what's happening.
     * In these scenarios, window.innerWidth is reporting a retina display &
     * isn't the correct pixel value for what we need:
     * iPhone 4 portrait:     window.innerWidth:980,  screen.width:320,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 4 landscape:    window.innerWidth:981,  screen.width:480,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 5 portrait:     window.innerWidth:980,  screen.width:320,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 5 landscape:    window.innerWidth:835,  screen.width:637,
     * isMobile:false, isTablet:true,  isDesktop:false
     * iPhone 6 portrait:     window.innerWidth:981,  screen.width:375,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 6 landscape:    window.innerWidth:980,  screen.width:667,
     * isMobile:false, isTablet:true,  isDesktop:false
     * iPhone 6+ portrait:    window.innerWidth:980,  screen.width:414,
     * isMobile:true,  isTablet:false, isDesktop:false
     * iPhone 6+ landscape:   window.innerWidth:980,  screen.width:736,
     * isMobile:false, isTablet:true,  isDesktop:false
     *
     * In these scenarios, screen.width is incorrect & we need to use the
     * window.innerWidth value:
     * Desktop (full window): window.innerWidth:1600, screen.width:1600,
     * isMobile:false, isTablet:false, isDesktop:true
     * Desktop (tablet size): window.innerWidth:783,  screen.width:1600,
     * isMobile:false, isTablet:true,  isDesktop:false
     * Desktop (mobile size): window.innerWidth:494,  screen.width:1600,
     * isMobile:true,  isTablet:false, isDesktop:false
     */

    // Utility.log('isMobile: ' + isMobile + '|' + window.innerWidth + '|' +
    // screen.width);
    return isMobile;
  }

  function isTablet() {
    var isTablet = false;
    if (!Utility.isMobile()) {
      // Desktop Resized Browser Check
      if ((window.innerWidth >= 550) && (window.innerWidth < 1024)) {
        isTablet = true;
      } else if ((screen.width < window.innerWidth)
        && (screen.width >= 550) && (screen.width <= 1024)) { // iOS Check
        isTablet = true;
      }
    }
    /*
     * iPad portrait:         window.innerWidth:980,  screen.width:768,
     * isMobile:false, isTablet:true,  isDesktop:false
     * iPad landscape:        window.innerWidth:1024, screen.width:1024,
     * isMobile:false, isTablet:false, isDesktop:true
     * iPad mini portrait:    window.innerWidth:980,  screen.width:768,
     * isMobile:false, isTablet:true,  isDesktop:false
     * iPad mini landscape:   window.innerWidth:1024, screen.width:1024,
     * isMobile:false, isTablet:false, isDesktop:true
     */
    // Utility.log('isTablet: ' + isTablet + '|' + window.innerWidth + '|'
    // + screen.width);
    return isTablet;
  }

  function isDesktop() {
    var isDesktop = !!((!Utility.isMobile() && !Utility.isTablet()));
    // Utility.log('isDesktop: ' + isDesktop + '|' + window.innerWidth + '|'
    // + screen.width);
    return isDesktop;
  }

  function isAndroid() {
    return hasClass('android', document.documentElement);
  }

  var isIE = function () {
    var rv = false;
    var ua; var
      re;
    if (navigator.appName === 'Microsoft Internet Explorer') {
      ua = navigator.userAgent;
      re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
      if (re.exec(ua) !== null) {
        rv = true;
      }
    } else if (navigator.appName === 'Netscape') {
      ua = navigator.userAgent;
      re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
      var re2 = new RegExp('Edge/([0-9]{1,}[.0-9]{0,})');
      if (re.exec(ua) !== null || re2.exec(ua) !== null) {
        rv = true;
      }
    }
    return rv;
  };

  var isEdge = function () {
    return $('html').hasClass('ieedge');
  };

  function isWinEdge() {
    return (navigator.platform.toLowerCase().indexOf('win') !== -1 && navigator.userAgent.toLowerCase().indexOf('edge') !== -1);
  }

  /*
   * This is a hack to enable the :active state on iphone
   * https://developer.mozilla.org/en-US/docs/Web/CSS/:active
   */
  function enableActive() {
    if (isMobile()) {
      $('body').on('touchstart', function () { });
    }
  }

  /*
   * This attach a calback function to be trigger when
   * all images are loaded inside an element.
   *
   * It only works for <img tag.
   *
   */
  function imagesReady(element, callback) {

    $(element).each(function (index, el) {
      var $images = $('img', el);
      var totalImages = $images.length;
      var count = 0;

      $images.on('load', function () {

        if (++count === totalImages) {
          $images.off('load');
          callback(el);

        }
      });
    });
  }

  function prefix() {
    var styles = window.getComputedStyle(document.documentElement, '');
    var pre = (Array.prototype.slice
      .call(styles)
      .join('')
      .match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o'])
    )[1];
    var dom = ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1];

    return {
      dom: dom,
      lowercase: pre,
      css: '-' + pre + '-',
      js: pre[0].toUpperCase() + pre.substr(1),
    };
  }


  function getTanDeg(deg) {
    var rad = deg * Math.PI / 180;
    return Math.tan(rad);
  }

  function getMonthNameFromNbr(nbr) {
    // returns full name of month based on nbr (January for 1);
    var monthNameArr = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return monthNameArr[nbr - 1];
  }

  function isIE11() {
    return $('html').hasClass('ie11');
  }

  function isIOS() {
    return $('html').hasClass('ios');
  }

  function isSafari() {
    var ua = navigator.userAgent.toLowerCase();
    var isSafari = false;
    try {
      isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]'; }(!window.safari || safari.pushNotification));
    } catch (err) {
      console.log(err);
    }

    isSafari = (isSafari || ((ua.indexOf('safari') !== -1) && (!(ua.indexOf('chrome') !== -1) && (ua.indexOf('version/') !== -1))));

    return isSafari;
  }

  function getClickCoords(evt) {
    var posX;
    var posY;

    if (evt.pageX || evt.pageY) {
      posX = evt.pageX;
      posY = evt.pageY;
    } else {
      posX = evt.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      posY = evt.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }

    return {
      x: posX,
      y: posY,
    };
  }

  /** ********************************** */
  /*
  /* initLazyLoadingIO
  /* Triggered when element is nearly to be visible using IntersectionObserver
  /*
  /******************************************************** */
  function initLazyLoadingIO(elements, callbackFn) {

    const options = {
      root: null,
      rootMargin: screen.height / 2 + 'px',
    };

    if ('IntersectionObserver' in window) {
      var lazyElementObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var lazyElement = entry.target;
            if (callbackFn) {
              callbackFn(lazyElement);
            }
            lazyElementObserver.unobserve(lazyElement);
          }
        });
      }, options);

      elements.forEach(function (lazyElement) {
        lazyElementObserver.observe(lazyElement);
      });
    }
  }

  /** ********************************** */
  /*
  /* initDeferLoading
  /* Triggered when page has been downloaded
  /*
  /******************************************************** */
  function initDeferLoading(callbackFn) {

    window.addEventListener('load', function () {
      callbackFn();
    });
  }

  // Create a render event
  function createEvent(eventName, data) {
    var event;
    if (typeof window.CustomEvent === 'function') {
      event = new CustomEvent(eventName, {
        bubbles: true,
        detail: data,
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, true, false, data);
    }

    return event;
  }

  function isElementInView(element, fullyInView, offset) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height() + (offset || 0);
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();
    var inView;

    pageTop -= offset || 0;

    if (fullyInView === true) {
      inView = (pageTop < elementTop && pageBottom > elementBottom);
    } else {
      inView = (elementTop <= pageBottom && elementBottom >= pageTop);
    }

    return inView;
  }

  function getCurrentBreakpoint() {
    var breakpoint;
    var width = window.innerWidth;

    // get the size of the image
    if (width < Constants.breakpoints.sm) {
      breakpoint = 'xsmall';
    } else if (width < Constants.breakpoints.lg) {
      breakpoint = 'medium';
    } else if (width <= Constants.breakpoints.xl) {
      breakpoint = 'large';
    } else {
      breakpoint = 'xlarge';
    }

    return {
      breakpoint: breakpoint,
      ratio: window.devicePixelRatio <= 1 ? 1 : 2,
    };
  }

  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    }

    return uri + separator + key + '=' + value;

  }

  function formatPhone(phone) {
    var numbers = phone.replace(/\D/g, '');
    var char = {
      0: '(',
      3: ') ',
      6: '-',
    };
    var formattedPhone = '';
    var i;

    for (i = 0; i < numbers.length; i++) {
      formattedPhone += (char[i] || '') + numbers[i];
    }

    return formattedPhone;
  }

  /**
  * Get the url parameters.
  * @return {Object} Parameters from the URL.
  */
  function getUrlParameters() {
    const regex = /(\?|&)([^=]+)=([^&]+)/gm;
    var urlParams = window.location.search;
    var match;
    var params = {};

    while ((match = regex.exec(urlParams)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (match.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      var key = match[2];
      var value = match[3];
      params[key] = value;
    }

    return params;
  }

  /**
  * Get the url parameter value, depending on the parameter name.
  * @param {String} parameter Parameter name to look for.
  * @return {String} Parameter value from the parameter being searched for.
  */
  function getUrlParameterValue(parameter) {
    var params = getUrlParameters();
    for (var key in params) {
      if (key.toLowerCase() === parameter.toLowerCase()) {
        return params[key];
      }
    }
    return false;
  }

  /**
  * Set the url parameter value, depending on the parameter name.
  * @param {String} parameter Parameter name to look for.
  * @param {String} newVal New value for the url parameter.
  * @return {String} Url value with the new/modifed parameter value.
  */
  function setUrlParameterValue(url, parameterKey, parameterValue, updateUrl) {
    var urlQueryString;

    var key = encodeURIComponent(parameterKey);
    var value = encodeURIComponent(parameterValue);

    var baseUrl = url.split('?')[0];
    var newParam = key + '=' + value;
    var params = '?' + newParam;

    if (url.split('?')[1] === undefined) { // if there are no query strings, make urlQueryString empty
      urlQueryString = '';
    } else {
      urlQueryString = '?' + url.split('?')[1];
    }

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      var updateRegex = new RegExp('([?&])' + key + '[^&]*');
      var removeRegex = new RegExp('([?&])' + key + '=[^&;]+[&;]?');

      if (typeof value === 'undefined' || value === null || value === '') { // Remove param if value is empty
        params = urlQueryString.replace(removeRegex, '$1');
        params = params.replace(/[&;]$/, '');

      } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
        params = urlQueryString.replace(updateRegex, '$1' + newParam);

      } else if (urlQueryString === '') { // If there are no query strings
        params = '?' + newParam;
      } else { // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    }

    // no parameter was set so we don't need the question mark
    params = params === '?' ? '' : params;

    if (updateUrl) {
      var hash = window.location.hash;
      window.history.replaceState({}, null, baseUrl + params + hash);
    }

    return baseUrl + params;
  }

  function reevaluatePictureFill() {
    if (isIE11()) {
      picturefill({ reevaluate: true });
    }
  }

  /**
  * Generic function to set a cookie. When cookie must expires with the session, expDays should be null or zero
  * @param {String} key.
  * @param {String} value.
  * @param {Number} expDays expiration days that will be used to create a date. When no expiration date es necessary
  *                 expDays should be zero or null
  *
  */
  function setCookie(key, value, expDays) {
    var expires = ';';
    if (expDays && expDays > 0) {
      var d = new Date();
      d.setTime(d.getTime() + (expDays * 24 * 60 * 60 * 1000));
      expires = ';expires=' + d.toUTCString() + ';';
    }
    document.cookie = key + '=' + value + expires + 'path=/';
  }

  /*
  * Generic function to obtain a cookie value.
  * @param {String} key.
  */
  function getCookie(name) {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
  }

  function validateZipcode(zipValue, successCallback, errorCallback) {
    const zipUrl = '/platform/api/v1/address/citystate/' + zipValue;
    const validZipcode = new RegExp(/^\d{5}$/);
    const isZipcodeRegexApproved = zipValue.match(validZipcode);
    if (isZipcodeRegexApproved) {
      var request = new XMLHttpRequest();
      request.open('GET', zipUrl);
      request.onload = function () {
        if (request.status === 200) {
          const data = JSON.parse(request.response);
          const zipData = data && data[zipValue] ? data[zipValue] : false;
          const result = zipData !== null && zipData.address && zipData.address.countryRegion === 'United States';
          if (result) {
            successCallback();
          } else {
            errorCallback();
          }
        } else {
          errorCallback();
        }
      };

      request.onerror = function () {
        errorCallback();
      };

      request.send(); // send the request
    } else {
      errorCallback();
    }
  }

  /**
  * Scrolls the page to the desired position on the required duration.
  * @param {Int} targetPositon Position to scroll to.
  * @param {Int} duration Duration of the scroll to do.
  */
  function scrollTo(targetPositon, duration) {
    var startPosition = window.pageYOffset;
    var distance = targetPositon - startPosition;
    var startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      var timeElapsed = currentTime - startTime;
      var run = ease(timeElapsed, startPosition, distance, duration);

      window.scrollTo(0, run);

      if (timeElapsed <= duration) {
        requestAnimationFrame(animation);
      } else {
        window.scrollTo(0, targetPositon);
      }
    }

    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
  }

  /**
  * Returns the first element based on the given class.
  * @param {string} className Position to scroll to.
  */
  function getFirstElementFromClass(className) {
    var element = document.getElementsByClassName(className);
    var result;
    if (element.length > 0) {
      result = element[0];
    }
    return result;
  }

  /**
   * Helper to fire an event on an element.
   * @param  {HTMLElement} element   Element to trigger event.
   * @param  {String} event   Event name.
   */
  function fireEvent(element, event) {
    var evt;
    if (document.createEventObject) {
      // dispatch for IE
      evt = document.createEventObject();
      return element.fireEvent('on' + event, evt);
    }
    // dispatch for firefox + others
    evt = document.createEvent('HTMLEvents');
    evt.initEvent(event, true, true); // event type,bubbling,cancelable
    return !element.dispatchEvent(evt);
  }

  /**
  * Returns the domain of a url.
  * @param {string} url Url direction.
  */
  function getUrlDomain(url) {
    var domain = '';
    if (url) {
      domain = url.match(/:\/\/(.[^/]+)/)[1];
    }
    return domain;
  }

  // Expose the following variables and functions
  return {
    // variables

    // methods
    debounce: debounce,
    log: log,
    logBlue: logBlue,
    warn: warn,
    error: error,
    toggleClass: toggleClass,
    addClass: addClass,
    removeClass: removeClass,
    svgLoader: svgLoader,
    loadSvgInMemory: loadSvgInMemory,
    hasClass: hasClass,
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop,
    isAndroid: isAndroid,
    isIE: isIE,
    isEdge: isEdge,
    isWinEdge: isWinEdge,
    outerWidthWithMargin: outerWidthWithMargin,
    siblings: siblings,
    children: children,
    defaultTo: defaultTo,
    createHTML: createHTML,
    quickDeepClone: quickDeepClone,
    guid: guid,
    enableActive: enableActive,
    imagesReady: imagesReady,
    prefix: prefix,
    getTanDeg: getTanDeg,
    getMonthNameFromNumber: getMonthNameFromNbr,
    isIE11: isIE11,
    isIOS: isIOS,
    isSafari: isSafari,
    isElementInView: isElementInView,
    initLazyLoadingIO: initLazyLoadingIO,
    initDeferLoading: initDeferLoading,
    createEvent: createEvent,
    getCurrentBreakpoint: getCurrentBreakpoint,
    updateQueryStringParameter: updateQueryStringParameter,
    formatPhone: formatPhone,
    // This line comes from Shopping Tools Branch
    getClickCoordinates: getClickCoords,
    getUrlParameters: getUrlParameters,
    getUrlParameterValue: getUrlParameterValue,
    setUrlParameterValue: setUrlParameterValue,
    reevaluatePictureFill: reevaluatePictureFill,
    getCookie: getCookie,
    setCookie: setCookie,
    validateZipcode: validateZipcode,
    scrollTo: scrollTo,
    removeClassFromSvg: removeClassFromSvg,
    addClassToSvg: addClassToSvg,
    getFirstElementFromClass: getFirstElementFromClass,
    fireEvent: fireEvent,
    getUrlDomain: getUrlDomain,
  };
}());
